export default __webpack_public_path__ + "static/media/parkshare-team-eating.ac0a174a.jpg";